import {
  Component,
  AfterViewInit,
  OnInit,
} from "@angular/core";


@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent implements  OnInit {
  ngOnInit(): void {
    throw new Error("Method not implemented.");
  }
 }
